import { render, staticRenderFns } from "./ActiveList.vue?vue&type=template&id=2a205eb4&scoped=true&"
import script from "./ActiveList.vue?vue&type=script&lang=js&"
export * from "./ActiveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a205eb4",
  null
  
)

export default component.exports